var compareByDepth = function (a, b) {
    return a.depth - b.depth;
};

export { compareByDepth };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/dist/es/render/utils/compare-by-depth.mjs
// module id = FdiE
// module chunks = 0